import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ApiHelperService } from 'src/app/services/api-helper-service/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {

  private isAuthenticated = false;

  constructor(
    private router: Router,
    private apiHelperService: ApiHelperService
  ) { }

  getIsAuthenticated() {
    return this.isAuthenticated;
  }

  login() {
    this.isAuthenticated = true;
  }

  logout() {
    const logoutStatus = { "status": "logout" };
    this.apiHelperService.signoutUser(logoutStatus);
    localStorage.removeItem('lmsAccessToken');
    localStorage.removeItem('lmsRefreshToken');
    this.isAuthenticated = false;
  }

  canActivate(): boolean {
    if (!this.isAuthenticated) {
      this.router.navigateByUrl('landing');
      return false;
    }
    return true;
  }

}
